export const DATA_TESTIDS = {
  SELFSHOW: {
    SHOW_STATUS: 'showingStatus',
    ACCESS_CODE: 'accessCodeInfo',
    CODE_AVAILABILITY: 'codeAvailabilityInfo',
    EMAIL_INFO: 'emaiTextInfo',
    RETURN_TO_VIEW_INFO: 'returnToViewInfo',
    CHANGE_DATE_BUTTON: 'changeDateTimeButton',
    CANCEL_BUTTON: 'cancelShowingButton',
    CANCEL_SHOWING_NO: 'selfShowCancelShowingButtonNo',
    CANCEL_SHOWING_YES: 'selfShowCancelShowingButtonYes',
    SAVE_SHOWING_BUTTON: 'selfShowSaveShowingButton',
    CODE_HELPER_BUTTON: 'accessCodeHelpButton',
  },
  SCHEDULE: {
    DATE_PICKER: 'selfShowDatePicker',
    TIME_PICKER: 'selfShowTimePicker',
    TIME_OPTION: 'selfShowTimeOption',
    SELECT_TODAY: 'day_button_today',
    SELECT_TOMORROW: 'day_button_tomorrow',
    SELECT_THIS_WEEK: 'day_button_this_week',
    SELECT_NEXT_WEEK: 'day_button_next_week',
    NEXT_BUTTON: 'showing-nav-next',
    SCHEDULING_STATUS: 'showingSchedulingStatus',
  },
  PDP: {
    SELF_TOUR: 'property-listing-website__static-details-bar__self-tour-button',
  },
};
